@if (authenticationService.user) {
  @if (isExternalUser) {
    <app-idle />
  }
  <app-header
    [userName]="userName"
    [menuItems]="menuItems"
    (logout)="logout()"
    (redirectToHomePage)="redirectToHomePage()"
    >
    <ng-container id="left-content">
      <ng-container *accessView="['HomePage.UI', 'MemberPage.UI', 'AuthorizationPage.UI']">
        <button
          pButton
          aria-label="menu"
          type="button"
          class="p-button-text"
          data-test-id="menu-icon"
          [icon]="menuIcon"
          (click)="toggleSidebar()"
          (mouseover)="changeMenuIcon()"
          (mouseout)="changeToDefaultIcon()"
          >
        </button>
      </ng-container>
    </ng-container>
    <ng-container id="right-content">
      <mnc-app-notifications />
    </ng-container>
  </app-header>
  <ng-sidebar-container class="app-container" [class]="{ 'right-side-sidebar': isNotesOpened }">
    <ng-sidebar *accessView="['MemberPage.UI', 'Claims.Read']" [(opened)]="isOpened" mode="push">
      <app-sidebar />
    </ng-sidebar>
    <div aria-label="Sidebar Content" ng-sidebar-content class="sidebar-content">
      <router-outlet></router-outlet>
    </div>
  </ng-sidebar-container>
  <app-footer></app-footer>
}


